const initialState = {
    isOpen: false,
    isActive: false,
};
const modalAddresses = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_ADDRESSES':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalAddresses;
